import type { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { OrderManagementSettingsTabRedirect } from "../order-management-settings-tab-redirect";
import { shippingSettingsRoutes as originalRoutes } from "./shipping";

export const shippingSettingsRoutes: PermissionedRouteObject[] =
  originalRoutes.map((route) => {
    if (route.path !== "fulfillment-cutoff") {
      return route;
    }
    const { lazy: _lazy, ...base } = route;
    return {
      ...base,
      element: (
        <OrderManagementSettingsTabRedirect
          from="/settings/fulfillment-cutoff"
          section="fulfillment-promise"
        />
      ),
    };
  });
